<template>
  <section class="pw-page">
    <p class="eyebrow">账号安全</p>
    <h1>{{ mustChange ? '首次登录，请设置新密码' : '修改登录密码' }}</h1>
    <p class="subtitle">{{ mustChange ? '初始密码只用于首次登录。设置新密码后，才能进入管理平台。' : '建议定期更换密码，修改后其他设备的登录将自动失效。' }}</p>
    <div class="form-card">
      <el-form @submit.prevent="submit">
        <label for="old-password">当前密码</label>
        <el-input id="old-password" v-model="oldPassword" type="password" show-password autocomplete="current-password" placeholder="输入当前密码" size="large" />
        <label for="new-password">新密码</label>
        <el-input id="new-password" v-model="newPassword" type="password" show-password autocomplete="new-password" placeholder="至少 10 个字符" size="large" />
        <label for="confirm-password">确认新密码</label>
        <el-input id="confirm-password" v-model="confirmPassword" type="password" show-password autocomplete="new-password" placeholder="再次输入新密码" size="large" @keyup.enter="submit" />
        <p class="tip">密码长度建议 12 位以上，不要与其他网站共用。</p>
        <p v-if="error" class="error" role="alert">{{ error }}</p>
        <div class="actions">
          <el-button type="primary" :loading="loading" @click="submit">保存新密码</el-button>
          <el-button v-if="!mustChange" @click="router.push('/')">返回首页</el-button>
        </div>
      </el-form>
    </div>
  </section>
</template>
<script setup>
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { authState, changePassword, authErrorMessage } from '../auth'
const router = useRouter()
const mustChange = computed(() => !!authState.user?.mustChangePassword)
const oldPassword = ref('')
const newPassword = ref('')
const confirmPassword = ref('')
const error = ref('')
const loading = ref(false)
async function submit() {
  if (loading.value) return
  if (!oldPassword.value || !newPassword.value || !confirmPassword.value) {
    error.value = '请填写完整的密码信息'
    return
  }
  if (newPassword.value.length < 10) {
    error.value = '新密码至少需要 10 个字符'
    return
  }
  if (newPassword.value !== confirmPassword.value) {
    error.value = '两次输入的新密码不一致'
    return
  }
  loading.value = true
  error.value = ''
  try {
    await changePassword(oldPassword.value, newPassword.value)
    oldPassword.value = ''; newPassword.value = ''; confirmPassword.value = ''
    ElMessage.success('密码已更新')
    await router.replace('/')
  } catch (e) {
    error.value = authErrorMessage(e, '修改失败，请稍后重试')
  } finally {
    loading.value = false
  }
}
</script>
<style scoped>
.pw-page{max-width:620px}.eyebrow{color:#6d9377;letter-spacing:2px;font-size:12px}
h1{font-size:28px;margin:8px 0 10px}.subtitle{color:#64766b;font-size:14px;line-height:1.8;margin-bottom:26px}
.form-card{background:#fff;border:1px solid #e6eee5;border-radius:14px;padding:30px}
.el-form{display:flex;flex-direction:column;gap:11px}label{font-size:14px;color:#37483f;margin-top:8px}
.tip{font-size:12px;color:#65746d}.error{font-size:13px;color:#ad3838;margin:2px 0}
.actions{display:flex;gap:8px;margin-top:14px}
.actions :deep(.el-button--primary){background:#376747;border-color:#376747}
@media(max-width:480px){.form-card{padding:20px}h1{font-size:23px}}
</style>
